import { render, staticRenderFns } from "./prepayments.vue?vue&type=template&id=4ff34ab4&scoped=true&"
import script from "./prepayments.vue?vue&type=script&lang=js&"
export * from "./prepayments.vue?vue&type=script&lang=js&"
import style0 from "./prepayments.vue?vue&type=style&index=0&id=4ff34ab4&prod&lang=scss&scoped=true&"
import style1 from "./prepayments.vue?vue&type=style&index=1&id=4ff34ab4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff34ab4",
  null
  
)

export default component.exports